<template>
  <div>
    <v-container fluid class="content-wrapper px-4 px-md-4">
      <v-row>
        <v-col cols="12">
          <v-btn
            v-if="ordersQuery"
            depressed
            rounded
            small
            color="blue"
            class="white--text font-weight-bold"
            :to="{
              name: 'Orders',
              query: { toggleOrder: 'services' },
            }"
          >
            <v-icon color="black" small class="mr-2">
              mdi-arrow-left
            </v-icon>
            Back to my Orders
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card class="resource-card">
            <v-row class="pa-xs-1 pa-sm-5 pa-8">
              <v-col cols="12" sm="4" lg="4" xl="4">
                <v-img
                  class="resource-image"
                  lazy-src="@/assets/img/blur.jpg"
                  :src="resource.logoUrlPublic"
                  contain
                ></v-img>
              </v-col>
              <v-col cols="12" sm="8" lg="8" xl="8">
                <div class="d-flex flex-column">
                  <div class="mb-4 d-flex flex-row align-center">
                    <h3 class="primary200--text header-marketplace mr-2">
                      {{ resource.name }}
                    </h3>
                    <v-btn
                      icon
                      v-if="resource.isFavorite != null && resource.isFavorite === false"
                      @click.stop="addFavorite(resource)"
                      color="neutral500"
                    >
                      <v-icon>mdi-heart-outline</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      v-if="resource.isFavorite != null && resource.isFavorite === true"
                      @click.stop="removeFavorite(resource, index)"
                      color="primary300"
                    >
                      <v-icon>mdi-heart</v-icon>
                    </v-btn>
                  </div>
                  <v-divider class="my-4"></v-divider>
                  <div class="label-marketplace">Description:</div>
                  <div v-if="resource.description">
                    <div v-if="!readMore">
                      {{ resource.description.slice(0, 200)
                      }}{{ resource.description.length > 200 ? '...' : '' }}
                    </div>
                    <div v-if="resource.description.length > 200">
                      <div v-if="readMore">{{ resource.description }}</div>
                    </div>
                    <div v-if="resource.description.length > 200" class="d-flex justify-end">
                      <v-btn
                        text
                        @click="readMore = !readMore"
                        class="text-decoration-underline text-bold"
                      >
                        {{ !readMore ? 'Read More' : 'Read Less' }}
                      </v-btn>
                    </div>
                  </div>
                  <v-divider class="my-4"></v-divider>
                  <div class="label-marketplace">Provider:</div>
                  <router-link
                    v-if="$router.currentRoute.meta.requiresAuth"
                    :to="{ name: 'MarketplaceProvider', params: { id: resource.provider.id } }"
                  >
                    {{ resource.provider.name }}
                  </router-link>
                  <router-link
                    v-else
                    :to="{
                      name: 'PublicMarketplaceProvider',
                      params: { id: resource.provider.id },
                    }"
                    >{{ resource.provider.name }}
                  </router-link>
                  <v-divider class="my-4"></v-divider>
                  <div class="label-marketplace">Hosting Institution:</div>
                  <div class="neutral500--text">
                    {{ resource.provider.hostingInstitution.name }}
                  </div>
                  <v-divider class="my-4"></v-divider>
                  <div class="label-marketplace" v-if="resource.tags.length > 0">Tags</div>
                  <div>
                    <v-chip
                      v-for="(tag, index) in resource.tags"
                      :key="'tag-' + resource.id + '-' + index"
                      class="mr-2"
                      :color="color(index)"
                    >
                      {{ tag }}
                    </v-chip>
                  </div>
                  <v-row class="mx-0 mt-8" v-if="!roles">
                    <v-col cols="12" md="5">
                      <v-btn
                        block
                        depressed
                        rounded
                        large
                        color="primary200"
                        class="white--text font-weight-bold"
                        data-cy="order"
                        @click="modalLogIn = true"
                      >
                        Order Request
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row
                    class="mx-0 mt-8"
                    v-else-if="
                      providerId != resource.provider.id &&
                        resource.publicContactsVerified.length > 0
                    "
                  >
                    <v-col cols="12" md="5" v-if="roles === 'researcher' && resource.orderable">
                      <v-btn
                        block
                        depressed
                        rounded
                        large
                        color="primary200"
                        class="white--text font-weight-bold"
                        data-cy="order"
                        @click="modalOrder = true"
                      >
                        {{ !ordersPending ? 'Order Request' : 'Order Status' }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" sm="4" lg="4" xl="4">
                <div class="pt-2 pl-2" v-if="$store.getters.roles === 'super-admin'">
                  <v-icon>$vuetify.icons.eye</v-icon>
                  &nbsp; <b>{{ resource.views }} registered views</b>
                  <br />
                  <v-icon>$vuetify.icons.eye</v-icon>
                  &nbsp; <b>{{ resource.viewsNonRegistered }} non registered views</b>
                </div>
              </v-col>
              <v-col cols="12">
                <v-tabs v-model="tab" show-arrows active-class="neutral800--text">
                  <v-tabs-slider color="neutral800"></v-tabs-slider>
                  <v-tab>{{ $t('basic') }}</v-tab>
                  <v-tab>{{ $t('classification') }}</v-tab>
                  <v-tab>{{ $t('contact') }}</v-tab>
                  <v-tab v-show="isEquipment">{{ $t('equipment') }}</v-tab>
                  <v-tab>{{ $t('management') }}</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                  <v-tab-item
                    :transition="false"
                    :reverse-transition="false"
                    :key="0"
                    class="px-4 py-6 text-left"
                  >
                    <div class="label-marketplace mt-6">Prerequisites:</div>
                    <div v-html="resource.technicalRequirements"></div>
                    <div class="label-marketplace mt-6">Tagline:</div>
                    <div>
                      {{ resource.tagline }}
                    </div>
                    <div class="label-marketplace mt-6">Use Cases:</div>
                    <div
                      v-for="(usecase, index) in resource.useCases"
                      :key="'usecase-' + resource.id + '-' + index"
                    >
                      - {{ usecase.text }}
                    </div>
                    <div
                      v-if="resource.relatedResources && resource.relatedResources.length > 0"
                      class="label-marketplace mt-6"
                    >
                      Related Services:
                    </div>
                    <div v-for="rsrc in resource.relatedResources" :key="'rsrc-' + rsrc.id">
                      <router-link
                        v-if="$router.currentRoute.meta.requiresAuth"
                        :to="{ name: 'MarketplaceService', params: { id: rsrc.id } }"
                      >
                        {{ rsrc.name }}
                      </router-link>
                      <router-link
                        v-else
                        :to="{ name: 'PublicMarketplaceService', params: { id: rsrc.id } }"
                      >
                        {{ rsrc.name }}
                      </router-link>
                    </div>
                  </v-tab-item>
                  <v-tab-item
                    :transition="false"
                    :reverse-transition="false"
                    :key="1"
                    class="px-4 py-6 text-left"
                  >
                    <div class="label-marketplace">Scientific Domain / Subdomain:</div>
                    <div
                      v-for="(scientific, index) in resource.scientifics"
                      :key="'scientific-' + resource.id + '-' + index"
                    >
                      {{ scientific.domain }} / {{ scientific.subDomain }}
                    </div>
                    <div class="label-marketplace  mt-6">Category / Subcategory:</div>
                    <div
                      v-for="(category, index) in resource.categories"
                      :key="'category-' + resource.id + '-' + index"
                    >
                      {{ category.category }} / {{ category.subCategory }}
                    </div>
                    <div class="label-marketplace  mt-6">Access Modes:</div>
                    <div>
                      {{ resource.accessModes.map(item => item.name).join(', ') }}
                    </div>
                    <div class="label-marketplace  mt-6">Access Types:</div>
                    <div>
                      {{ resource.accessTypes.map(item => item.name).join(', ') }}
                    </div>
                    <div class="label-marketplace  mt-6">Target Users:</div>
                    <div>
                      {{ resource.targets.map(item => item.name).join(', ') }}
                    </div>
                  </v-tab-item>
                  <v-tab-item
                    :transition="false"
                    :reverse-transition="false"
                    :key="2"
                    class="px-4 py-6 text-left"
                  >
                    <div v-if="resource.publicContactsVerified.length > 0">
                      <div
                        v-for="(contact, index) in resource.publicContactsVerified"
                        :key="'pubic-contact-' + resource.id + '-' + index"
                        class="d-flex flex-column mb-6"
                      >
                        <div v-if="contact.verified">
                          <div class="pb-2">
                            <span class="label-marketplace">First Name: </span>
                            {{ contact.firstname }}
                          </div>
                          <div class="pb-2">
                            <span class="label-marketplace">Last Name: </span>
                            {{ contact.lastname }}
                          </div>
                          <div class="pb-2" v-if="contact.position">
                            <span class="label-marketplace">Position: </span>
                            {{ contact.position }}
                          </div>
                          <div class="pb-2" v-if="contact.phone">
                            <span class="label-marketplace">Phone: </span>
                            {{ contact.phone }}
                          </div>
                          <div class="pb-2">
                            <span class="label-marketplace">Email: </span> {{ contact.email }}
                          </div>
                          <div class="pb-2">
                            <v-btn
                              depressed
                              rounded
                              large
                              color="black"
                              outlined
                              class="mt-5 pl-16 pr-16 black--text font-weight-bold"
                              data-cy="submit"
                              :href="'mailto:' + contact.email"
                            >
                              <v-icon>mdi-email-outline</v-icon>
                              Contact
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="label-marketplace">Helpdesk Email:</div>
                    <div>
                      {{ resource.helpDeskEmail }}
                    </div>
                  </v-tab-item>
                  <v-tab-item
                    :transition="false"
                    :reverse-transition="false"
                    :key="3"
                    class="px-4 py-6 text-left"
                  >
                    <div class="label-marketplace">Manufacturer:</div>
                    <div>
                      {{ resource.manufacturer }}
                    </div>
                    <div class="label-marketplace mt-6">Model and Type:</div>
                    <div>
                      {{ resource.model }}
                    </div>
                    <div class="label-marketplace mt-6" v-if="resource.operationalMode">
                      Operational Mode:
                    </div>
                    <div v-if="resource.operationalMode">
                      {{ resource.operationalMode.name }}
                    </div>
                    <div class="label-marketplace mt-6" v-if="resource.availabilityPolicies">
                      Availability Policy:
                    </div>
                    <div v-if="resource.availabilityPolicies">
                      <!--                      {{ resource.availabilityPolicies.map(item => item.text).join(', ') }}-->
                      <div v-for="(plc, i) in resource.availabilityPolicies" :key="'plc' + i">
                        {{ plc.text }}
                      </div>
                    </div>
                  </v-tab-item>
                  <v-tab-item
                    :transition="false"
                    :reverse-transition="false"
                    :key="4"
                    class="px-4 py-6 text-left"
                  >
                    <div class="label-marketplace">Service Level:</div>
                    <div v-if="resource.serviceLevel">
                      <a target="_blank" :href="resource.serviceLevel" class="on-hover-underline">{{
                        resource.serviceLevel
                      }}</a>
                    </div>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
              <v-col cols="12">
                <v-divider class="mt-4 mb-8"></v-divider>
                <div class="label-marketplace">Other services from the same provider</div>
                <v-row>
                  <v-col cols="12" class="text-right">
                    <router-link
                      v-if="!$router.currentRoute.meta.requiresAuth && viewMore"
                      class="primary200--text"
                      :to="{
                        name: 'PublicMarketplaceServices',
                        query: { providers: this.resource.provider.id },
                      }"
                    >
                      {{ $t('view-more') }}
                    </router-link>
                    <router-link
                      v-else-if="viewMore"
                      class="primary200--text"
                      :to="{
                        name: 'MarketplaceServices',
                        query: { providers: this.resource.provider.id },
                      }"
                    >
                      {{ $t('view-more') }}
                    </router-link>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    v-for="resource in relatedResources"
                    :key="'resource-' + resource.id"
                    class="mb-1 d-flex"
                    style="flex-direction:column"
                  >
                    <v-hover v-slot="{ hover }">
                      <v-card
                        :elevation="hover ? 4 : 0"
                        :class="{ 'on-hover': hover }"
                        class="resource-card flex-grow-1"
                        @click="onResourceClick(resource)"
                      >
                        <v-row class="pa-xl-8 pa-lg-8 pa-sm-8 pa-2">
                          <v-col cols="12" xl="3" sm="3" lg="3">
                            <v-img
                              max-height="159"
                              lazy-src="@/assets/img/blur.jpg"
                              class="resource-image"
                              :src="resource.logoUrlPublic"
                              contain
                            ></v-img>
                          </v-col>
                          <v-col cols="12" xl="9" sm="9" lg="9">
                            <div class="d-flex flex-column">
                              <div>
                                <h3 class="mb-1 neutral800--text">{{ resource.name }}</h3>
                                <div class="mb-1">
                                  {{ resource.provider.name }}
                                </div>
                              </div>
                              <div class="mt-2">
                                <v-chip
                                  v-for="(tag, index) in resource.tags"
                                  :key="'tag-' + resource.id + '-' + index"
                                  class="mr-2"
                                  :color="color(index)"
                                >
                                  {{ tag }}
                                </v-chip>
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-hover>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="modalOrder" max-width="1000px">
        <v-card
          class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
        >
          <v-card-title class="px-0 py-0">
            <v-row class="mx-0 px-2" align="center">
              <v-col cols="11" class="text-center d-flex justify-center align-center">
                {{ !ordersPending ? 'Order Service' : 'Order Status' }}
              </v-col>
              <v-col cols="1" class="pl-0">
                <v-btn fab small text @click="modalOrder = false">
                  <v-icon color="neutral500">
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider class="mt-1 mb-6 my-sm-6 my-lg-6 my-xl-6 my-md-6"></v-divider>
          <v-card-text v-if="!ordersPending" class="pa-0">
            <v-form ref="form" v-model="valid" :lazy-validation="false">
              <v-row>
                <v-col cols="12" class="pt-0">
                  <p class="label-info">
                    Payments and pricing must by discussed directly with the service provider
                  </p>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <label>From</label>
                  <input-date
                    v-model="order.fromDate"
                    class="required"
                    :rules="requiredRule()"
                  ></input-date>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <label>To</label>
                  <input-date
                    v-model="order.toDate"
                    class="required"
                    :rules="requiredRule()"
                  ></input-date>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <label>Use Case</label>
                  <v-textarea
                    v-model="order.useCase"
                    :placeholder="'Use Case'"
                    outlined
                    clearable
                    :rules="requiredRule()"
                    class="required"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <label>Additional Prerequisites</label>
                  <p class="label-info">{{ $t('order-additional-info-text') }}</p>
                  <v-textarea
                    v-model="order.additionalInformation"
                    :placeholder="'Additional Prerequisites'"
                    outlined
                    clearable
                  ></v-textarea>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-checkbox
                    :rules="requiredRule()"
                    label="I acknowledge that the order adheres to the service’s prerequisites"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-text v-else>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headersOrder"
                  :items="orders"
                  hide-default-footer
                  disable-pagination
                >
                  <template v-slot:item.orderDate="{ item }">
                    <span>
                      {{ formatDateLocaleAE(item.createdTimestamp) }}
                    </span>
                  </template>
                  <template v-slot:item.status="{ item }">
                    <v-chip :color="getOrderColor(item.status.id)">
                      {{
                        item.status.description +
                          (item.statusExplicit ? ' - ' + item.statusExplicit : '')
                      }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions v-if="!ordersPending">
            <v-row style="width: 100%">
              <v-col cols="6">
                <v-btn
                  block
                  depressed
                  rounded
                  large
                  class="neutral800--text font-weight-bold"
                  color="neutral"
                  outlined
                  @click="modalOrder = false"
                  >{{ $t('cancel') }}
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  :disabled="!valid || dateIsAfter(this.order.fromDate, this.order.toDate)"
                  block
                  depressed
                  rounded
                  large
                  class="white--text font-weight-bold"
                  color="black"
                  @click="submitOrder"
                  >{{ $t('submit') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="modalLogIn" max-width="1000px">
        <v-card
          class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8"
        >
          <v-card-title class="px-0 py-0">
            <v-row class="mx-0 px-2" align="center">
              <v-col cols="11" class="text-center d-flex justify-center align-center">
                This action requires authentication
              </v-col>
              <v-col cols="1" class="pl-0">
                <v-btn fab small text @click="modalLogIn = false">
                  <v-icon color="neutral500">
                    mdi-close
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider class="mt-1 mb-6 my-sm-6 my-lg-6 my-xl-6 my-md-6"></v-divider>
          <v-card-text class="pa-0">
            Only authenticated users are allowed to perform this action. Please
            <router-link :to="{ name: 'MarketplaceService', params: { id: resource.id } }"
              >Log In</router-link
            >
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import EventBus from '@/helpers/event-bus';
import util from '@/mixins/util.js';
import InputDate from '@/components/shared/inputs/InputDate';
import Vue from 'vue';

export default {
  name: 'MarketplaceResource',
  mixins: [util],
  components: {
    InputDate,
  },
  data() {
    return {
      breadcrumbs: this.$router.currentRoute.meta.breadcrumbPath,
      resource: {
        provider: {
          id: null,
          hostingInstitution: {
            name: null,
          },
        },
        tags: [],
        useCases: [],
        scientifics: [],
        categories: [],
        accessModes: [],
        accessTypes: [],
        publicContacts: [],
        helpDeskEmail: null,
        technicalRequirements: null,
        targets: [],
        publicContactsVerified: [],
      },
      tab: null,
      isEquipment: false,
      modalOrder: false,
      valid: false,
      order: {
        resource: {},
        useCase: null,
        additionalInformation: null,
        fromDate: null,
        toDate: null,
        status: {},
      },
      orders: [],
      providerId: null,
      roles: null,
      relatedResources: [],
      viewMore: false,
      readMore: false,
      modalLogIn: false,
      ordersQuery: '',
    };
  },
  created() {
    this.providerId = sessionStorage.getItem('providerId');
    this.roles = localStorage.getItem('roles');
  },
  mounted() {
    let id = this.$route.params.id;
    if (id != null) {
      EventBus.$emit('waiting', true);
      this.axios
        .get('/api/v1/resources/' + id)
        .then(res => {
          this.resource = res.data;
          if (
            this.resource.categories.filter(e => e.category === 'Instruments & Equipment').length >
            0
          ) {
            this.isEquipment = true;
          } else {
            this.isEquipment = false;
          }
          this.$set(this.breadcrumbs, this.breadcrumbs.length - 1, { text: this.resource.name });
        })
        .catch(error => {
          console.log({ error });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
      if (this.$router.currentRoute.meta.requiresAuth) {
        this.axios
          .get('/api/v1/orders?resourceId=' + id)
          .then(res => {
            this.orders = res.data.content;
          })
          .catch(error => {
            console.log({ error });
          })
          .finally(() => {
            EventBus.$emit('waiting', false);
          });
      }
      this.ordersQuery = this.$route.query.ordersQuery;
    }
  },
  methods: {
    submitOrder() {
      console.log('Order resource ' + this.resource.id);
      this.order.resource = this.resource;
      EventBus.$emit('waiting', true);
      this.axios
        .post('/api/v1/orders', this.order)
        .then(() => {
          console.log('Success');
          EventBus.$emit('snackbar', {
            text: 'Order successfully submitted',
          });
          this.order.status = {
            description: 'Requested',
            id: 'REQUESTED',
          };
          this.order.createdTimestamp = this.getNowUtc();
          this.orders.push(this.order);
          this.modalOrder = false;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(EventBus.$emit('waiting', false));
    },
    addFavorite(item) {
      EventBus.$emit('waiting', true);
      this.axios
        .post('/api/v1/favorites/' + item.id)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'Favorite added successfully',
          });
          item.isFavorite = true;
        })
        .catch(error => {
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    removeFavorite(item) {
      EventBus.$emit('waiting', true);
      this.axios
        .delete('/api/v1/favorites/' + item.id)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'Favorite removed successfully',
          });
          item.isFavorite = false;
        })
        .catch(error => {
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    onResourceClick(item) {
      if (!this.$router.currentRoute.meta.requiresAuth) {
        this.$router.push({
          name: 'PublicMarketplaceService',
          params: { id: item.id },
        });
      } else {
        this.$router.push({
          name: 'MarketplaceService',
          params: { id: item.id },
        });
      }
    },
    login() {
      const basePath = window.location.origin.toString();
      Vue.$keycloak.login({ redirectUri: basePath + '/app/dashboard' });
    },
  },
  computed: {
    headersOrder() {
      let headers = [
        /*{ text: 'ID', value: 'id', sortable: true },*/
        { text: 'Order Date', value: 'orderDate', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Use Case', value: 'useCase', sortable: true },
        { text: 'Additional Prerequisites', value: 'additionalInformation', sortable: true },
      ];
      return headers;
    },
    ordersPending() {
      if (
        this.orders.some(x =>
          ['REQUESTED', 'ACCEPTED_BY_PROVIDER', 'ACCEPTED_BY_RESEARCHER'].includes(x.status.id),
        )
      ) {
        return true;
      }
      if (this.orders.some(x => ['Active', 'Future Date'].includes(x.statusExplicit))) {
        return true;
      }
      return false;
    },
  },
  watch: {
    'resource.provider.id': function(val) {
      if (val != null) {
        this.axios
          .get('/api/v1/resources?size=11&providers=' + val)
          .then(res => {
            this.relatedResources = res.data.content.filter(
              resource => resource.id != this.resource.id,
            ); // filter out this resource
            this.viewMore = res.data.total > res.data.contentSize;
          })
          .catch(error => {
            console.log({ error });
          });
      }
    },
  },
};
</script>

<style scoped>
.resource-image {
  border-radius: 19.875px;
}

a:hover {
  text-decoration: underline;
}
</style>
